import { NgClass } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IconComponent, IconName } from '../icon/icon.component';

@Component({
  selector: 'web-design-system-tag',
  imports: [NgClass, IconComponent],
  templateUrl: './tag.component.html',
  styleUrl: './tag.component.scss',
})
export class TagComponent {
  @Input() public label: string;
  @Input() public type: 'red' | 'blue' | 'info' = 'info';
  @Input() public isDeletable: boolean;
  @Input() public iconName: IconName;

  @Output() public delete = new EventEmitter<void>();
}
